import { Flex } from "../../mantine-passthroughs/index.js";
import { Badge } from "../Badge.js";
import { jsx } from "react/jsx-runtime";

//#region src/components/badge/badge-list/BadgeList.tsx
/**
* BadgeList display a collection of labeled badges, each optionally colored.
*/
const BadgeList = ({ badgelist, "data-testid": testId }) => {
	return /* @__PURE__ */ jsx(Flex, {
		gap: "xs",
		"data-testid": testId,
		children: badgelist.map(({ label, color }, idx) => /* @__PURE__ */ jsx(Badge, {
			color,
			children: label
		}, `${label}-${idx}`))
	});
};

//#endregion
export { BadgeList };